import { render, staticRenderFns } from "./RoomExamInfoItem.vue?vue&type=template&id=53de03c0&"
import script from "./RoomExamInfoItem.vue?vue&type=script&lang=js&"
export * from "./RoomExamInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53de03c0')) {
      api.createRecord('53de03c0', component.options)
    } else {
      api.reload('53de03c0', component.options)
    }
    module.hot.accept("./RoomExamInfoItem.vue?vue&type=template&id=53de03c0&", function () {
      api.rerender('53de03c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Exam/Info/RoomExamInfoItem.vue"
export default component.exports